import { render, staticRenderFns } from "./VpsService.vue?vue&type=template&id=ff22fa10&"
import script from "./VpsService.vue?vue&type=script&lang=js&"
export * from "./VpsService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff22fa10')) {
      api.createRecord('ff22fa10', component.options)
    } else {
      api.reload('ff22fa10', component.options)
    }
    module.hot.accept("./VpsService.vue?vue&type=template&id=ff22fa10&", function () {
      api.rerender('ff22fa10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/VPS/VpsService.vue"
export default component.exports